import type {
  IModelSettings,
  TWritableModelSetting,
} from "@frontend-shared/types";
import { createContext } from "react";

// NOTE: NSAI-4838 — app-wide model defaults. `defaultModel` / `defaultSummaryModel`
// / `defaultImageModel` are the server-persisted per-(user, project) defaults;
// `lastUsedModelOrAssistant` stays device-local. Provided once high in the tree so
// any page reads the current defaults (and updates them) via `useModelSettings`
// without its own fetch.
export interface IModelSettingsContext {
  modelSettings: IModelSettings;
  // NOTE: NSAI-4838 — resolves once the write settles: `true` if it persisted,
  // `false` if the server write failed (the optimistic value is rolled back).
  // Never rejects, so fire-and-forget callers stay safe; callers that need to
  // order dependent work after the write can await it.
  // NOTE: NSAI-5786 — writable keys only; the deployment-wide
  // `forcedNewChatModelName` is served read-only and cannot be set.
  setModelSettings: (
    key: TWritableModelSetting,
    value: string | null,
  ) => Promise<boolean>;
  isModelSettingsLoading: boolean;
}

export const ModelSettingsContext = createContext<
  IModelSettingsContext | undefined
>(undefined);
